import * as React from "react"
import type { SVGProps } from "react"
const SvgSort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 13.14a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72V5.97L6.13 7.84a1 1 0 0 1-.7.28q-.4 0-.7-.28a1 1 0 0 1-.3-.71q0-.41.3-.71L8.3 2.84q.14-.15.33-.21a1 1 0 0 1 .74 0 1 1 0 0 1 .33.21l3.6 3.6q.3.3.29.7a1 1 0 0 1-.32.7q-.3.28-.7.29a1 1 0 0 1-.7-.29L10 5.97v6.17q0 .43-.29.72a1 1 0 0 1-.71.28m6 8.58a1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.22l-3.6-3.6a1 1 0 0 1-.29-.7 1 1 0 0 1 .32-.7q.3-.27.7-.28t.7.28L14 18.32v-6.18q0-.42.29-.71a1 1 0 0 1 .71-.29.97.97 0 0 1 1 1v6.18l1.88-1.88a1 1 0 0 1 .68-.27q.42 0 .72.27.3.3.3.72 0 .4-.3.7l-3.58 3.58q-.14.15-.32.22a1 1 0 0 1-.38.06" />
  </svg>
)
export default SvgSort
